import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Cookie, BarChart3, Globe } from 'lucide-react';
import { SEO } from '@/hooks/useSEO';

export default function CookiePolicyPage() {
  const { t } = useTranslation();

  const cookieTypes = [
    {
      icon: Cookie,
      titleKey: 'cookiePolicy.functional.title',
      descKey: 'cookiePolicy.functional.description',
      examplesKey: 'cookiePolicy.functional.examples',
    },
    {
      icon: BarChart3,
      titleKey: 'cookiePolicy.analytics.title',
      descKey: 'cookiePolicy.analytics.description',
      examplesKey: 'cookiePolicy.analytics.examples',
    },
    {
      icon: Globe,
      titleKey: 'cookiePolicy.thirdParty.title',
      descKey: 'cookiePolicy.thirdParty.description',
      examplesKey: 'cookiePolicy.thirdParty.examples',
    },
  ];

  return (
    <div className="container max-w-4xl py-12">
      <SEO
        title={t('cookiePolicy.title')}
        description={t('meta.cookiePolicy')}
        path="/cookiepolicy"
      />
      <h1 className="text-3xl font-bold tracking-tight mb-2">{t('cookiePolicy.title')}</h1>
      <p className="text-muted-foreground mb-8">{t('cookiePolicy.lastUpdated')}</p>

      <section className="prose prose-sm max-w-none mb-10">
        <h2 className="text-xl font-semibold mb-3">{t('cookiePolicy.whatAreCookies.title')}</h2>
        <p className="text-muted-foreground">{t('cookiePolicy.whatAreCookies.description')}</p>
      </section>

      <section className="mb-10">
        <h2 className="text-xl font-semibold mb-4">{t('cookiePolicy.typesTitle')}</h2>
        <div className="grid gap-4 md:grid-cols-3">
          {cookieTypes.map((ct) => {
            const Icon = ct.icon;
            return (
              <Card key={ct.titleKey}>
                <CardHeader className="pb-3">
                  <div className="flex items-center gap-2">
                    <Icon className="h-5 w-5 text-primary" />
                    <CardTitle className="text-base">{t(ct.titleKey)}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="space-y-2">
                  <p className="text-sm text-muted-foreground">{t(ct.descKey)}</p>
                  <p className="text-sm text-muted-foreground italic">{t(ct.examplesKey)}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </section>

      <section className="prose prose-sm max-w-none mb-10">
        <h2 className="text-xl font-semibold mb-3">{t('cookiePolicy.manageCookies.title')}</h2>
        <p className="text-muted-foreground">{t('cookiePolicy.manageCookies.description')}</p>
      </section>

      <section className="prose prose-sm max-w-none">
        <h2 className="text-xl font-semibold mb-3">{t('cookiePolicy.contact.title')}</h2>
        <p className="text-muted-foreground">
          {t('cookiePolicy.contact.description')}{' '}
          <a href="mailto:info@postnummerservice.se" className="text-primary underline underline-offset-4">
            info@postnummerservice.se
          </a>
        </p>
      </section>
    </div>
  );
}
